import Vue from 'vue';
import address from './address';
import { capitalize, capitalizeName, capitalizeWord } from './capitalize';
import cep from './cep';
import cnpj from './cnpj';
import council from './council';
import cpf from './cpf';
import currency from './currency';
import date from './date';
import dateOld from './date-old';
import decibel from './decibel';
import deg from './deg';
import diopter from './diopter';
import identity from './identity';
import micron from './micron';
import millimeter from './millimeter';
import mmHg from './mmhg';
import number from './number';
import pad from './pad';
import percent from './percent';
import phone from './phone';
import tuss from './tuss';
import unit from './unit';

const filters = {
  address,
  capitalize,
  capitalizeName,
  capitalizeWord,
  cep,
  cnpj,
  council,
  cpf,
  currency,
  date,
  dateOld,
  decibel,
  deg,
  diopter,
  identity,
  micron,
  millimeter,
  mmHg,
  number,
  pad,
  percent,
  phone,
  tuss,
  unit,
};

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

export default filters;
